// extracted by mini-css-extract-plugin
export default {"bgstars":"BGStars_bgstars__4tGod","shadow":"BGStars_shadow__s-W6X","topshadow":"BGStars_topshadow__rI7zA"};